import styled from "styled-components/macro";
import { MixinFont } from "../mixins";

export const BubbleCont = styled.div`
  margin-right: 2em;
  transform: translate(0px, -1px);
  align-self: center;
  ${MixinFont};
  color: ${(props) => props.theme.colors.textDimmed};

`;

export const MainCont = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  :hover {
    color: ${(props) => props.theme.colors.text};
  }

  & > p {
    margin-bottom: 0;
    margin-left: 4px;
    transform: translate(0px, 1px);
  }

  & > svg {
  }

  :hover > .arrow > path{
    stroke: ${(props) => props.theme.colors.text};
  }

  .arrow {
    padding-left: 0;
    path {
      stroke: ${(props) => props.theme.colors.textDimmed};
    }
  }
`;
export const SelectCont = styled.div`
  position: absolute;
  margin-top: 0.5em;
  display: flex;
  flex-direction: column;
  max-height: 5em;
  gap: 8px;
  padding: 8px;
  border: 1px solid #DFE1EB;
  border-radius: 5px;

  background-color: ${(props) => props.theme.colors.bgSecondary};

  & > li {
    display: flex;
    gap: 8px;
    margin: 0 0.5em 0 0.5em;

    :hover{
      color: ${(props) => props.theme.colors.text};
    }

  }

`;

export const SvgBubble = styled.div`
  & > svg {
    transform: translate(0px, 2px);
    border: 1px solid #DFE1EB;
    border-radius: 99px;
  }

`;
